module.exports = "/static/assets/140a12db35626907175324712db456a7.gif";